module.exports = __webpack_public_path__ + "static/media/27.6e09e6e9.mp3";